import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Sistema, PermisoSistema } from '../models/sistema.interface';

@Injectable({
  providedIn: 'root'
})
export class SistemaService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.url}/sistemas`;

  obtenerMisSistemas(): Observable<Sistema[]> {
    return this.http.get<Sistema[]>(`${this.apiUrl}/mis-sistemas`);
  }

  obtenerTodos(): Observable<Sistema[]> {
    return this.http.get<Sistema[]>(`${this.apiUrl}`);
  }

  obtenerPermisos(codigo: string, empresaId?: string): Observable<PermisoSistema> {
    let params = new HttpParams();
    if (empresaId) {
      params = params.set('empresaId', empresaId);
    }
    return this.http.get<PermisoSistema>(`${this.apiUrl}/${codigo}/permisos`, {
      params,
    });
  }

  verificarAcceso(codigo: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/${codigo}/verificar-acceso`);
  }
}
